
// const basePath = 'https://ahmadhassan.design/';
const basePath = 'https://admin.theclockwork.app/';
const basePathImage = 'https://d2iosncs8hpu1u.cloudfront.net/';

export const environment = {
  basePath,
  production: true,
  // wheelApiPath: 'https://api.wheel-size.com/v2/', // REMOVED - Using backend proxy now
  // wheel_user_key: '4b5baf87183531c1004dbe1ee774931b', // REMOVED - Security fix
  storagePath: basePath + 'storage/',
  apiPath: basePath + 'api/',
  //paymentPath: 'http://payment.tunerstop.com',
  basePathImage,
  stripe: {
    publishableKey: 'pk_live_51Q9TCQP85GWHOZRiTNLNXg2AKUDu5U3oTF9siO7xr43j3J6DykvhmU6XUn5j9zXhFo532FR5Ln00dWKsD9UPczrE00Ge7LKkTk'  // TODO: Replace with actual production key
  }
};
